import React from 'react'
import type { IconDefaultProps } from '../../../models/types'

const SoundOffIcon = ({ className, color }: IconDefaultProps): JSX.Element => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 17 15.106'
      className={className || 'rf-w-4 rf-h-4'}
    >
      <path
        d='M4.069,12.039l.3-.5-.138-.083H4.069Zm0-6.972v.581H4.23l.138-.083ZM9.883,1.581h.581a.581.581,0,0,0-.88-.5Zm0,13.943-.3.5a.581.581,0,0,0,.88-.5ZM13.3,6.5l-.411-.411-.822.822.411.411Zm2.466,4.108.411.411L17,10.2l-.411-.411Zm.822-3.286L17,6.91l-.822-.822-.411.411Zm-4.11,2.464-.411.411.822.822.411-.411ZM4.069,11.457H1.744V12.62H4.069Zm-2.325,0a.58.58,0,0,1-.581-.581H0A1.743,1.743,0,0,0,1.744,12.62Zm-.581-.581V6.229H0v4.648Zm0-4.648a.58.58,0,0,1,.581-.58V4.486A1.743,1.743,0,0,0,0,6.229Zm.581-.58H4.069V4.486H1.744Zm2.624-.083L10.182,2.08l-.6-1L3.77,4.569ZM9.3,1.581V15.525h1.163V1.581Zm.88,13.445L4.368,11.54l-.6,1,5.813,3.486Zm2.3-7.7,3.288,3.286.822-.822L13.3,6.5ZM15.767,6.5,12.479,9.785l.822.822,3.288-3.286Z'
        transform='translate(0 -1)'
        fill={color || '#FFF'}
      />
    </svg>
  )
}

export default SoundOffIcon
